/* src/app/app.component.scss */
.backToPreview {
  padding: 1px;
  border: 1px solid red;
  background-color: red;
  color: white;
  position: absolute;
  top: 10px;
  right: 0px;
  width: 180px;
  text-align: center;
  z-index: 1031;
  border-radius: 15px;
}
.backToPreview:hover {
  cursor: pointer;
}
.backToPreview a {
  border-bottom: 1px dotted white;
}
.backToPreview .align-right {
  float: right;
  padding-right: 20px;
}
@keyframes fadeInBlinkStay {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
.errorMessage {
  position: absolute;
  background: red;
  padding: 20px;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  border-radius: 10px;
  z-index: 10000;
  opacity: 0;
  animation: fadeInBlinkStay 2s forwards;
}
.errorMessage.retrying {
  background: #6DCC09;
}
/*# sourceMappingURL=app.component.css.map */
